import type { FC, ReactElement } from "react"

import { THEME } from "@/3514/theme"

type TProps = { height?: number; width?: number; alt?: string }

const DefaultAvatarIcon: FC<TProps> = ({ height, width, alt }: TProps): ReactElement => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 37 37"
        fill="none"
        className="[border-radius:50%]"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>{alt || "User default avatar"}</title>
        <circle cx="18.5" cy="18.5001" r="18.5" fill={THEME.COLORS.white} />
        <mask
            id="mask0_1389_1939"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="37"
            height="38"
        >
            <circle cx="18.5" cy="18.5001" r="18.5" fill={THEME.COLORS.gray[500]} />
        </mask>
        <g mask="url(#mask0_1389_1939)">
            <circle cx="19" cy="15.0001" r="6" fill={THEME.COLORS.gray[23]} />
            <circle cx="19" cy="34.0001" r="12" fill={THEME.COLORS.gray[23]} />
        </g>
    </svg>
)

export { DefaultAvatarIcon }
